import React from "react";
import {withTranslate} from "react-redux-multilingual";
import ProgressiveImage from "react-progressive-image-loading";

const BookWithOffer = ({doctor, offer, removeOfferCache, translate}) => {
    return (
        <div className="offer-wrapper" hidden={!offer || (offer && doctor.id !== offer.doctor.id)}>
            <h6 className="mt-20 mb-20">{translate("offer")}</h6>
            <div className="offer-card shadow-4d">
                <div className="booked-offer-details-with-image">

                <span className="offer-image">
                   <ProgressiveImage
                       preview="/images/offer-image-placeholder.png"
                       src={offer.image}
                       render={(src, style) => <img alt="head" src={src} style={style}/>}
                   />
              </span>
                    <div className="booked-offer-details">
                        <span>{offer ? offer.name : ""}</span>
                        <span className="discount icon">
                    <img className="icon" src="./../../../images/floos.png" alt="money"/>
                            {offer ?
                                <span
                                    className="mr-12">{offer.price + " " + translate("currency")}</span>

                                : null}
                </span>
                    </div>
                </div>
                <a href="/" className="cursor-pointer" onClick={(e) => removeOfferCache(e)}>
                    <img alt="close" src="/images/close_button.png"/></a>
            </div>
        </div>
    )
};


export default withTranslate(BookWithOffer);